import { request } from '../request';

export const toolsApi = {
  listTools: () => request('/tools'),

  toggleTool: (toolName) =>
    request(`/tools/${encodeURIComponent(toolName)}/toggle`, {
      method: 'PATCH'
    }),

  updateAsyncExecution: (toolName, asyncExecution) =>
    request(`/tools/${encodeURIComponent(toolName)}/async-execution`, {
      method: 'PATCH',
      body: JSON.stringify({ async_execution: asyncExecution })
    })
};
